import * as React from 'react';
type Props = {
  className?: string;
};
export function SpiceNone({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Spice none"
      className={className}
    >
      <path
        d="M32.7401 6.58732L25.962 13.8316M7.27275 33.4127L11.4286 28.9475M24.473 12.5C25.7143 10 26.083 8.24901 25.3572 6.07145M18.3003 15.2182C19.7219 15.4418 22.0038 16.0088 24.2241 17.6164C25.0212 18.1938 25.665 18.7998 26.1776 19.3622M20 38.5714C30.2567 38.5714 38.5714 30.2567 38.5714 20C38.5714 9.7433 30.2567 1.42859 20 1.42859C9.7433 1.42859 1.42859 9.7433 1.42859 20C1.42859 30.2567 9.7433 38.5714 20 38.5714ZM23.3748 12.138C29.256 13.3638 25.6665 22.0615 23.3715 24.7976C21.3109 27.2541 18.603 28.7966 15.5098 29.2012C13.5714 29.4547 9.28573 28.9286 8.81568 27.5337C8.77287 27.2113 9.61881 27.0777 11.0866 25.9107C14.1463 23.4754 15.1644 21.4558 16.6474 18.0637C17.7431 15.5571 20.1815 11.4727 23.3748 12.138Z"
        stroke="currentColor"
      />
    </svg>
  );
}
